<div class="view-container">
  <div class="manufacturers">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Companies</label>
          <button 
            mat-flat-button type="button"
            color="accent"
            (click)="onClickAddCompany()"
            matTooltip="Add Company">
            <mat-icon>add</mat-icon>Add Company
          </button>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content>
            <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search companies by name</mat-label>
                <input matInput type="text"
                  [(ngModel)]="searchTerm"
                  (keyup.enter)="loadManufacturers()"
                  (keyup.esc)="searchTerm=''; loadManufacturers()"
                  name="searchTerm"
                  placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadManufacturers()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <button
                  type="submit"
                  mat-flat-button color="primary"
                  (click)="loadManufacturers()"
                  matTooltip="Search"
                  [class.button-spinner]="loading"
                  [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="contrast" *ngFor="let item of manufacturersDataSource.data"
          [class.banner-error]="item?.disabled"
          [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="5px">
            <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm" [matTooltip]="item?.id"></strong>
            <mat-icon>{{ item?.companyType === 1 ? 'kitchen' : item?.companyType === null ? '': 'home' }}</mat-icon>
          </div>
          <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
            <div fxFlex="70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
                <img class="option-img" aria-hidden [src]="item.logoUrl" height="15">
              </div>
              <div fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                <button mat-mini-fab color="accent" aria-label="Edit Company" matTooltip="Edit Company" (click)="onEditManufacturer(item?.id)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-mini-fab color="primary"
                  aria-label="Preview Impression"
                  matTooltip="Preview Impression"
                  (click)="onViewCompany(item.id)">
                  <mat-icon>preview</mat-icon>
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>
